// list of countries to fix empty data issues on global map
export const globalLocationId = 1;
export const globalMapCountryLocationsIds =
    '6,7,8,10,11,12,13,14,15,16,17,18,19,20,22,23,24,25,26,27,28,29,30,33,34,35,36,37,38,39,40,41,43,44,45,46,47,48,49,50,51,52,53,54,55,57,58,59,60,61,62,63,66,67,68,69,71,72,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,97,98,99,101,102,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,121,122,123,125,126,127,128,129,130,131,132,133,135,136,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,160,161,162,163,164,165,168,169,170,171,172,173,175,176,177,178,179,180,181,182,183,184,185,186,187,189,190,191,193,194,195,196,197,198,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,298,305,349,351,376,385,422,435,522';
export const locationsWithDetailedMapView = [
    135, 6, 95, 179, 163, 11, 142, 67, 180, 130, 72, 90, 62, 196, 93, 102, 86, 214, 165, 16, 51,
    523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541,
    542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560,
    561, 562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573,
];

export const africanUnionIds = [
    139, 141, 147, 148, 154, 168, 169, 170, 171, 172, 173, 175, 176, 177, 178, 179, 180, 181, 182,
    183, 184, 185, 186, 187, 189, 190, 191, 193, 194, 195, 196, 197, 198, 200, 201, 202, 203, 204,
    205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 435, 522, 25344,
];
export const countryLocationTypeId = 2;
export const europeanUnionAndUKIds = [
    45, 46, 47, 48, 51, 52, 54, 55, 58, 59, 60, 75, 76, 77, 78, 79, 80, 81, 82, 84, 86, 87, 88, 89,
    91, 92, 93, 95,
];
export const femaleGenderId = 2;
export const fiveYearAgeBands =
    '1,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,30,31,32,33,44,45,46,235';
export const maleGenderId = 1;

export const pediatricFocusAgeGroups = '164,2,3,4,5,6,7,8,37';
export const elderlyFocusAgeGroups = '284,16,17,18,19,20,30,31,32,235';
export const reproductiveFemaleAges = '7,8,9,10,11,12,13,14,15';
export const lifeCourseAges = '1,23,24,41,289,235';
export const adultFocusAges = '158,284,285';
export const fiveYearAgeBandsTwentyPlus = '9,10,11,12,13,14,15,16,17,18,19,20,30,31,32,235';

export const ExcelRowsExportLimit = 210000; // 210k
export const CSVRowsExportLimit = 1000000; // 1m
export const PDFRowsExportLimit = 175000; // 175k

export const populationMeasureId = 44;
